import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ctaLabel, offerUrl, sidebar } from '../data/story';
export function OfferSidebar() {
  return <motion.aside initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.35,
    ease: 'easeOut'
  }} aria-label="Featured offer" className="order-first flex w-full flex-col gap-3 lg:order-none lg:sticky lg:top-6 lg:w-[300px] lg:flex-shrink-0 lg:self-start" data-id="element-19" data-mp="8yv3f0oj8fwi">
      <span className="self-start rounded-full bg-purple-soft px-2.5 py-1 font-ui text-[9.5px] font-bold uppercase tracking-[0.1em] text-purple-brand" data-id="element-20" data-mp="dx4x16ulz8g0">
        {sidebar.badge}
      </span>

      <figure className="relative overflow-hidden rounded-md border border-neutral-200" data-id="element-21" data-mp="nw480w2ujg66">
        <img src={sidebar.photo.src} alt={sidebar.photo.alt} className="h-[260px] w-full object-cover object-center sm:h-[320px] lg:h-[300px]" data-id="element-22" data-mp="2tosrmvm5govn" />
        <figcaption className="absolute bottom-2 right-2 rounded bg-white/90 px-1.5 py-0.5 font-ui text-[10px] text-neutral-600" data-id="element-23" data-mp="3arvsenwh7qga">
          {sidebar.photo.caption}
        </figcaption>
      </figure>

      <section aria-label={sidebar.progress.title} className="rounded-lg border border-purple-line bg-purple-wash px-3.5 pb-3.5 pt-3" data-id="element-24" data-mp="3kq1ryyut8khz">
        <h2 className="font-ui text-[10px] font-bold uppercase tracking-[0.08em] text-purple-muted" data-id="element-25" data-mp="3picp5ty61s6u">
          {sidebar.progress.title}
        </h2>
        <div className="mt-2.5 flex items-center justify-between" data-id="element-26" data-mp="2bsisclszrpb">
          <div data-id="element-27" data-mp="2e58jbxsz6cx">
            <p className="font-article text-[22px] font-bold leading-none text-purple-deep" data-id="element-28" data-mp="7b5e7lqqq73i">
              {sidebar.progress.before.value}
            </p>
            <p className="mt-1 font-ui text-[9px] uppercase tracking-[0.05em] text-neutral-400" data-id="element-29" data-mp="c9q4otg6xcer">
              {sidebar.progress.before.label}
            </p>
          </div>
          <ArrowRight className="h-4 w-4 text-purple-brand/50" aria-hidden="true" data-id="element-30" data-mp="2e0tifrldn73j" />
          <div className="text-right lg:text-left" data-id="element-31" data-mp="260dpf8xuasex">
            <p className="font-article text-[22px] font-bold leading-none text-purple-deep" data-id="element-32" data-mp="2616yigk9tu08">
              {sidebar.progress.now.value}
            </p>
            <p className="mt-1 font-ui text-[9px] uppercase tracking-[0.05em] text-neutral-400" data-id="element-33" data-mp="2fzmhtxd23yz6">
              {sidebar.progress.now.label}
            </p>
          </div>
        </div>
        <p className="mt-2.5 rounded-full bg-purple-brand py-1 text-center font-ui text-[11px] font-bold text-white" data-id="element-34" data-mp="2ozj9m7uqtdyg">
          {sidebar.progress.badge}
        </p>
      </section>

      <section id="recipe" className="rounded-lg bg-purple-tint px-3.5 pb-4 pt-3.5 text-center" data-id="element-35" data-mp="2kwd5p6v3ryv5">
        <h2 className="font-ui text-[13px] font-bold leading-snug text-purple-deep" data-id="element-36" data-mp="2tqrmjdva7hgd">
          {sidebar.cta.heading}
        </h2>
        <a href={offerUrl} target="_blank" rel="noopener noreferrer sponsored" className="mt-2.5 block w-full rounded-full bg-purple-brand px-4 py-2.5 font-ui text-[12.5px] font-bold text-white shadow-[0_2px_6px_rgba(107,33,168,0.35)] transition-colors hover:bg-purple-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-brand" data-id="element-37" data-mp="38otojjmnzuvi">
          {ctaLabel}
        </a>
        <p className="mt-2 font-ui text-[9.5px] text-purple-muted/80" data-id="element-38" data-mp="3ib4ge4j8904e">
          {sidebar.cta.sub}
        </p>
      </section>

      <section aria-label={sidebar.summary.title} className="rounded-lg border border-neutral-200 bg-white px-3.5 pb-3.5 pt-3" data-id="element-39" data-mp="33lf7fn4w7rtk">
        <h2 className="font-ui text-[10px] font-bold uppercase tracking-[0.08em] text-neutral-400" data-id="element-40" data-mp="38f19ymhcefbn">
          {sidebar.summary.title}
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-41" data-mp="2zly1ytpguuoe">
          {sidebar.summary.items.map(item => <li key={item} className="relative pl-3.5 font-ui text-[11.5px] leading-snug text-neutral-600" data-id="element-42" data-mp="2konh4tqxocg0">
              <span aria-hidden="true" className="absolute left-0 font-bold text-purple-brand" data-id="element-43" data-mp="2pojnv0r0mhz9">
                •
              </span>
              {item}
            </li>)}
        </ul>
      </section>
    </motion.aside>;
}